var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 10.75C6.75 11.1625 7.0875 11.5 7.5 11.5C7.9125 11.5 8.25 11.1625 8.25 10.75C8.25 10.3375 7.9125 10 7.5 10C7.0875 10 6.75 10.3375 6.75 10.75ZM6.75 0.25V3.25H8.25V1.81C10.7925 2.1775 12.75 4.3525 12.75 7C12.75 9.9025 10.4025 12.25 7.5 12.25C4.5975 12.25 2.25 9.9025 2.25 7C2.25 5.74 2.6925 4.585 3.435 3.685L7.5 7.75L8.5575 6.6925L3.4575 1.5925V1.6075C1.815 2.8375 0.75 4.7875 0.75 7C0.75 10.7275 3.765 13.75 7.5 13.75C11.2275 13.75 14.25 10.7275 14.25 7C14.25 3.2725 11.2275 0.25 7.5 0.25H6.75ZM12 7C12 6.5875 11.6625 6.25 11.25 6.25C10.8375 6.25 10.5 6.5875 10.5 7C10.5 7.4125 10.8375 7.75 11.25 7.75C11.6625 7.75 12 7.4125 12 7ZM3 7C3 7.4125 3.3375 7.75 3.75 7.75C4.1625 7.75 4.5 7.4125 4.5 7C4.5 6.5875 4.1625 6.25 3.75 6.25C3.3375 6.25 3 6.5875 3 7Z",
    fill: "#26405E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.06c1316bf014f3aee90ebd7770624dc9.svg";
export { ForwardRef as ReactComponent };